import { useEffect, useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * useWBTTarget — resolves the current WBT target for the rower's
 * mode + profile. Returns { target, mode } or { target: null }
 * when there's no matching record (silent state, per spec §8).
 *
 * Params:
 *   modeKind   — 'on_water' | 'ergo'
 *   boatClass  — for on_water lookup ('M1x', '1x' etc — the endpoint
 *                accepts short slug and canonicalises it)
 */
export default function useWBTTarget(modeKind, boatClass) {
  const [target, setTarget] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const qs = new URLSearchParams({ mode: modeKind });
        if (boatClass) qs.set('boat_class', boatClass);
        const res = await fetch(`${API}/wbt/lookup?${qs.toString()}`, { credentials: 'include' });
        if (!res.ok) { if (!cancelled) setTarget(null); return; }
        const data = await res.json();
        if (!cancelled) setTarget(data);
      } catch {
        if (!cancelled) setTarget(null);
      }
    })();
    return () => { cancelled = true; };
  }, [modeKind, boatClass]);

  return {
    target: target?.target ?? null,
    mode: target?.mode ?? modeKind,
  };
}
